import { useState } from 'react';
import { Form } from 'antd';
import { changePassword } from '../../../../../services/customer/profileServices';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import ChangePasswordForm from '../../../forms/changePassword/ChangePasswordForm';
import DefaultModal from '../defaultModal/DefaultModal';
import './ChangePasswordModal.scss';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { ReactComponent as GRLogo } from '../../../../../resources/images/svg/GRLogo.svg';

export default function ChangePasswordModal() {
  const { width } = useWindowDimensions();
  const { showChangePasswordModal, setShowChangePasswordModal } = useModal();
  const [errors, setErrors] = useState({});
  const [form] = Form.useForm();
  const { trans, configInfo } = useTranslation();

  const handleSubmit = async (values) => {
    setErrors({});
    try {
      const res = await changePassword(values);
      if (res.status === 'success') {
        setShowChangePasswordModal(false);
        form.resetFields();
      }
    } catch (error) {
      setErrors(error.response.data.errors);
    }
  };

  const isGeorgia = configInfo?.countryCode === 'GE';

  return (
    <DefaultModal
      show={showChangePasswordModal && width >= 1024}
      setShow={setShowChangePasswordModal}
      className="change-password"
      width={630}
    >
      <div className="flex justify-between items-center pb-[50px]">
        <h1 className="m-0 text-3xl font-semibold">
          {trans('change_password')}
        </h1>
        {isGeorgia ? <GRLogo />
          : (
            <img
              src="/ticketLogos/mobileLogoArm.png"
              alt="Armenia Railway Logo"
              width={90}
              height={42}
            />
          )}
      </div>
      <ChangePasswordForm
        errors={errors}
        handleSubmit={handleSubmit}
        form={form}
      />
    </DefaultModal>
  );
}
